import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';

const Deposit = () => {
    const [amount, setAmount] = useState(0);
    const [remark, setRemark] = useState('');
    const [banks, setBanks] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState({
        qr1: '', qr2: '', upi1: '', upi2: ''
    });
    const [depositHistory, setDepositHistory] = useState([]);
    const [activeTab, setActiveTab] = useState('qr');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [copiedUpi, setCopiedUpi] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const userId = localStorage.getItem('userid');
            
            const banksResponse = await axios.get('https://singlewindowsecurities.com/Rest3/banks_api');
            const paymentMethodsResponse = await axios.get('https://singlewindowsecurities.com/Rest3/company_profile_api');
            const depositHistoryResponse = await axios.get(`https://singlewindowsecurities.com/Rest3/deposite_api/${userId}`);
            
            setBanks(banksResponse.data);
            setPaymentMethods(paymentMethodsResponse.data);
            setDepositHistory(depositHistoryResponse.data);
            
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleAmountPreset = (presetAmount) => {
        setAmount(presetAmount);
    };

    const copyToClipboard = (upiId) => {
        navigator.clipboard.writeText(upiId);
        setCopiedUpi(upiId);
        setTimeout(() => setCopiedUpi(null), 2000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (amount <= 0) {
            alert("Please enter a valid amount");
            return;
        }

        setIsSubmitting(true);
        try {
            const formData = new FormData();
            formData.append("dep_amt", amount);
            formData.append("dremark", remark);
            formData.append("user", localStorage.getItem('userid'));

            const response = await axios.post(
                'https://singlewindowsecurities.com/Rest3/web_deposite_submit_api', 
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                }
            );
            console.log(response.data);
            alert("Deposit request submitted successfully!");
            if(response.data.status == 0){
                setAmount(0);
                setRemark('');
                fetchData();
            }
        } catch (error) {
            console.error("Deposit submission error:", error);
            alert("Failed to submit deposit request");
        } finally {
            setIsSubmitting(false);
        }
    };

    const getStatusColor = (status) => {
        switch(status?.toLowerCase()) {
            case 'approved': return '#00C853';
            case 'pending': return '#D4AF37';
            case 'rejected': return '#FF5252';
            default: return '#888';
        }
    };

    return (
        <div className="deposit-page" style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
        }}>
            <Helmet>
                <title>Deposit Funds | Single Window Securities</title>
            </Helmet>

            {/* Header */}
            <div style={{
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div className="container py-3">
                    <div className="d-flex align-items-center justify-content-between">
                        <Link to="/dashboard" className="btn" style={{
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.3)',
                            borderRadius: '12px',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#D4AF37'
                        }}>
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        <h5 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>Deposit Funds</h5>
                        <div style={{ width: '36px' }}></div>
                    </div>
                </div>
            </div>

            <main className="deposit-content" style={{ padding: '16px' }}>
                {/* Payment Method Tabs */}
                <div className="d-flex gap-2 p-1 mb-4" style={{
                    background: 'rgba(20, 20, 20, 0.8)',
                    borderRadius: '30px',
                    border: '1px solid rgba(212, 175, 55, 0.15)'
                }}>
                    <button 
                        className={`btn flex-fill py-2 ${activeTab === 'qr' ? 'btn-golden' : ''}`}
                        onClick={() => setActiveTab('qr')}
                        style={{
                            background: activeTab === 'qr' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
                            border: 'none',
                            borderRadius: '30px',
                            color: activeTab === 'qr' ? '#000' : '#888',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <i className="fas fa-qrcode me-2"></i> QR Code
                    </button>
                    <button 
                        className={`btn flex-fill py-2 ${activeTab === 'upi' ? 'btn-golden' : ''}`}
                        onClick={() => setActiveTab('upi')}
                        style={{
                            background: activeTab === 'upi' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
                            border: 'none',
                            borderRadius: '30px',
                            color: activeTab === 'upi' ? '#000' : '#888',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <i className="fas fa-mobile-alt me-2"></i> UPI
                    </button>
                    <button 
                        className={`btn flex-fill py-2 ${activeTab === 'bank' ? 'btn-golden' : ''}`}
                        onClick={() => setActiveTab('bank')}
                        style={{
                            background: activeTab === 'bank' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
                            border: 'none',
                            borderRadius: '30px',
                            color: activeTab === 'bank' ? '#000' : '#888',
                            fontWeight: 'bold',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <i className="fas fa-university me-2"></i> Bank
                    </button>
                </div>

                {/* QR Code Payment */}
                {activeTab === 'qr' && (
                    <div style={{
                        background: 'rgba(20, 20, 20, 0.95)',
                        borderRadius: '24px',
                        border: '1px solid rgba(212, 175, 55, 0.2)',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <div className="row g-4">
                            {paymentMethods.qr1 && (
                                <div className="col-md-6 text-center">
                                    <h6 style={{ color: '#D4AF37', marginBottom: '12px' }}>UPI QR Code 1</h6>
                                    <img 
                                        src={'https://singlewindowsecurities.com/assets/images/'+paymentMethods.qr1} 
                                        alt="UPI QR Code 1" 
                                        style={{
                                            maxWidth: '200px',
                                            border: '2px solid rgba(212, 175, 55, 0.3)',
                                            borderRadius: '16px',
                                            padding: '8px',
                                            background: '#fff'
                                        }}
                                    />
                                </div>
                            )}
                            {paymentMethods.qr2 && (
                                <div className="col-md-6 text-center">
                                    <h6 style={{ color: '#D4AF37', marginBottom: '12px' }}>UPI QR Code 2</h6>
                                    <img 
                                        src={'https://singlewindowsecurities.com/assets/images/'+paymentMethods.qr2} 
                                        alt="UPI QR Code 2" 
                                        style={{
                                            maxWidth: '200px',
                                            border: '2px solid rgba(212, 175, 55, 0.3)',
                                            borderRadius: '16px',
                                            padding: '8px',
                                            background: '#fff'
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="amount-section mt-4">
                            <h6 style={{ color: '#D4AF37', marginBottom: '12px' }}>Enter Deposit Amount</h6>
                            <div className="d-flex gap-2 mb-3">
                                <button 
                                    className="btn flex-fill py-2"
                                    onClick={() => handleAmountPreset(1000)}
                                    style={{
                                        background: 'rgba(212, 175, 55, 0.1)',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#D4AF37',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ₹1,000
                                </button>
                                <button 
                                    className="btn flex-fill py-2"
                                    onClick={() => handleAmountPreset(5000)}
                                    style={{
                                        background: 'rgba(212, 175, 55, 0.1)',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#D4AF37',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ₹5,000
                                </button>
                                <button 
                                    className="btn flex-fill py-2"
                                    onClick={() => handleAmountPreset(10000)}
                                    style={{
                                        background: 'rgba(212, 175, 55, 0.1)',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#D4AF37',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ₹10,000
                                </button>
                            </div>
                            
                            <div className="mb-3">
                                <div className="input-group">
                                    <span className="input-group-text" style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRight: 'none',
                                        color: '#D4AF37',
                                        fontWeight: 'bold'
                                    }}>₹</span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        placeholder="Enter custom amount"
                                        min="100"
                                        step="100"
                                        style={{
                                            background: '#1a1a1a',
                                            border: '1px solid rgba(212, 175, 55, 0.3)',
                                            borderLeft: 'none',
                                            color: '#fff'
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    placeholder="Remark / Transaction ID"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff'
                                    }}
                                />
                            </div>
                            
                            <button 
                                className="btn w-100 py-3"
                                onClick={handleSubmit}
                                disabled={isSubmitting || amount <= 0}
                                style={{
                                    background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                                    border: 'none',
                                    borderRadius: '16px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isSubmitting && amount > 0) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                {isSubmitting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin me-2"></i> Processing...
                                    </>
                                ) : (
                                    "Submit Deposit Request"
                                )}
                            </button>
                        </div>
                    </div>
                )}

                {/* UPI Payment */}
                {activeTab === 'upi' && (
                    <div style={{
                        background: 'rgba(20, 20, 20, 0.95)',
                        borderRadius: '24px',
                        border: '1px solid rgba(212, 175, 55, 0.2)',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <h6 style={{ color: '#D4AF37', marginBottom: '16px' }}>UPI Payment Details</h6>
                        {paymentMethods.upi1 && (
                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center p-3" style={{
                                    background: '#1a1a1a',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(212, 175, 55, 0.2)'
                                }}>
                                    <span style={{ color: '#fff', fontFamily: 'monospace' }}>{paymentMethods.upi1}</span>
                                    <button 
                                        className="btn btn-sm"
                                        onClick={() => copyToClipboard(paymentMethods.upi1)}
                                        style={{
                                            background: 'rgba(212, 175, 55, 0.15)',
                                            color: '#D4AF37',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        {copiedUpi === paymentMethods.upi1 ? (
                                            <><i className="fas fa-check"></i> Copied!</>
                                        ) : (
                                            <><i className="fas fa-copy"></i> Copy</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                        {paymentMethods.upi2 && (
                            <div>
                                <div className="d-flex justify-content-between align-items-center p-3" style={{
                                    background: '#1a1a1a',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(212, 175, 55, 0.2)'
                                }}>
                                    <span style={{ color: '#fff', fontFamily: 'monospace' }}>{paymentMethods.upi2}</span>
                                    <button 
                                        className="btn btn-sm"
                                        onClick={() => copyToClipboard(paymentMethods.upi2)}
                                        style={{
                                            background: 'rgba(212, 175, 55, 0.15)',
                                            color: '#D4AF37',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        {copiedUpi === paymentMethods.upi2 ? (
                                            <><i className="fas fa-check"></i> Copied!</>
                                        ) : (
                                            <><i className="fas fa-copy"></i> Copy</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Bank Transfer */}
                {activeTab === 'bank' && (
                    <div style={{
                        background: 'rgba(20, 20, 20, 0.95)',
                        borderRadius: '24px',
                        border: '1px solid rgba(212, 175, 55, 0.2)',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <h6 style={{ color: '#D4AF37', marginBottom: '16px' }}>Bank Transfer Details</h6>
                        <div className="row g-3">
                            {banks.map((bank, index) => (
                                <div className="col-md-6" key={index}>
                                    <div style={{
                                        background: '#1a1a1a',
                                        borderRadius: '16px',
                                        border: '1px solid rgba(212, 175, 55, 0.15)',
                                        overflow: 'hidden'
                                    }}>
                                        <div className="p-3" style={{
                                            background: 'rgba(212, 175, 55, 0.1)',
                                            borderBottom: '1px solid rgba(212, 175, 55, 0.15)'
                                        }}>
                                            <i className="fas fa-university me-2" style={{ color: '#D4AF37' }}></i>
                                            <span className="fw-bold" style={{ color: '#D4AF37' }}>{bank.bank_name}</span>
                                        </div>
                                        <div className="p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <small style={{ color: '#888' }}>Account Name</small>
                                                <span style={{ color: '#fff', fontWeight: 'bold' }}>{bank.acc_name}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <small style={{ color: '#888' }}>Account Number</small>
                                                <span style={{ color: '#D4AF37', fontWeight: 'bold' }}>{bank.acc_number}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <small style={{ color: '#888' }}>IFSC Code</small>
                                                <span style={{ color: '#fff', fontFamily: 'monospace' }}>{bank.ifsc_code}</span>
                                            </div>
                                            {bank.branch && (
                                                <div className="d-flex justify-content-between">
                                                    <small style={{ color: '#888' }}>Branch</small>
                                                    <span style={{ color: '#fff' }}>{bank.branch}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Recent Deposits Section */}
                <div style={{
                    background: 'rgba(20, 20, 20, 0.95)',
                    borderRadius: '24px',
                    border: '1px solid rgba(212, 175, 55, 0.2)',
                    padding: '20px'
                }}>
                    <h6 style={{ color: '#D4AF37', marginBottom: '16px' }}>Recent Deposit History</h6>
                    {depositHistory.length > 0 ? (
                        <div>
                            {depositHistory.map((deposit, index) => (
                                <div key={index} className="d-flex justify-content-between align-items-center p-3 mb-2" style={{
                                    background: '#1a1a1a',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(212, 175, 55, 0.1)'
                                }}>
                                    <div>
                                        <div className="fw-bold" style={{ color: '#D4AF37' }}>₹{deposit.dep_amt}</div>
                                        <small style={{ color: '#888' }}>{deposit.dep_submit_date}</small>
                                    </div>
                                    <div className="text-end">
                                        <span style={{
                                            background: `rgba(${getStatusColor(deposit.dep_status) === '#00C853' ? '0,200,83' : getStatusColor(deposit.dep_status) === '#D4AF37' ? '212,175,55' : '255,82,82'}, 0.15)`,
                                            color: getStatusColor(deposit.dep_status),
                                            padding: '4px 10px',
                                            borderRadius: '20px',
                                            fontSize: '11px',
                                            fontWeight: 'bold'
                                        }}>
                                            {deposit.dep_status}
                                        </span>
                                        {deposit.admin_remarks && (
                                            <div><small style={{ color: '#666' }}>{deposit.admin_remarks}</small></div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <i className="fas fa-wallet" style={{ color: '#D4AF37', fontSize: '40px', opacity: 0.5 }}></i>
                            <p className="mt-2" style={{ color: '#888' }}>No deposit history found</p>
                        </div>
                    )}
                </div>
            </main>

            <style>
                {`
                    .btn-golden {
                        background: linear-gradient(145deg, #D4AF37, #B8960C);
                        transition: all 0.3s ease;
                    }
                    .btn-golden:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
                    }
                    input:focus {
                        box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
                        outline: none;
                        border-color: #D4AF37 !important;
                    }
                    input[type="number"]::-webkit-inner-spin-button,
                    input[type="number"]::-webkit-outer-spin-button {
                        opacity: 0.5;
                    }
                `}
            </style>
        </div>
    );
};

export default Deposit;